/* eslint-disable react/jsx-no-target-blank */
import { IPartyForUser } from '../../PartyClientResponse';
import './DonateCTA.scss';

const DonateCTA = ({ party }: { party: IPartyForUser }) => {
  const links = party.stage.links || {};
  return (
    <div className={'donate__cta'}>
      {Object.entries(links).map(([key, link]) => (
        <a
          key={key}
          target='_blank'
          href={link.url}
          className='donate-button'
          style={{ marginTop: 10, fontSize: 16 }}>
          {link.text}
        </a>
      ))}
    </div>
  );
};

export default DonateCTA;
